import React from 'react'
import { useAccountSecurityContext } from 'providers'
import SessionDismissible from 'session-dismissible'
import MFA from './MFA'
import { useRemindAccountSecurity } from '../utils'
import PasswordExpiry from './PasswordExpiry'

/**
 *
 */
const Index = () => {
    const { passwordSecurityState } = useAccountSecurityContext()
    const { remindPasswordExpiry, remindMFA } = useRemindAccountSecurity()

    if (remindPasswordExpiry) return <PasswordExpiry hasExpired={false} date={passwordSecurityState.data.passwordExpiryDate} />

    if (remindMFA) return <SessionDismissible storageKey='remindMFAPopup-closed'><MFA /></SessionDismissible>

    return null
}

export default Index
